import { isFiniteNumber, type Nil } from '@core';

import { u } from '../../styles';
import { Box } from '../Layout';
import { Heading3 } from '../Text';

export type ParameterStatsProps = {
    mean?: number | Nil;
    stdDev?: number | Nil;
};

export const ParameterStats = ({ mean, stdDev }: ParameterStatsProps) => {
    if (!isFiniteNumber(mean) && !isFiniteNumber(stdDev)) return null;

    return (
        <Box width="100%" p={u(1)} display="flex" justifyContent="center">
            <Heading3 textAlign="center">
                Avg {!isFiniteNumber(mean) ? '-' : mean}±{!isFiniteNumber(stdDev) ? '-' : stdDev} Std. dev.
            </Heading3>
        </Box>
    );
};
